import { Select } from "antd";
import { getIdentificationNumberTypes } from "api/coreapi/common";
import { useEffect, useState } from "react";
import { EnumTypeModel } from "shared/models/enumTypeModel";

interface IdentificationNumberTypesSelectProps {
    value?: number;
    onChange?: (value?: number) => void;
}

const IdentificationNumbersSelect: React.FC<IdentificationNumberTypesSelectProps> = (props) => {
    const {
        value,
        onChange        
    } = props;
    
    var [types, setTypes] = useState<EnumTypeModel[]>();
    const triggerChange = (changedValue?: number) => {
        onChange?.(changedValue);
      };

      const onSelectedItemChange = (newType: number) => {
        triggerChange(newType);
      };

    useEffect(() => {

        const getInfo = async () => {
            try {
                const res = await getIdentificationNumberTypes();
                setTypes(res.result);
            } catch (error: any) {
            }
        };

        getInfo();
    }, []);


    return (
        <Select
            
            defaultValue={value}
            onChange={onSelectedItemChange}
            options={types?.map((item) => ({
                value: item.id,
                label: item.displayName ?? item.name,
            }))}
        />

    );
}

export default IdentificationNumbersSelect;